import { SUBMENU_DEFAULT_VALUE } from '../../constants/route'
import { putApi } from '../../utils/api'

export function getEntityTabFilterStateApi({
  entityPlural,
  objectId,
  sub = SUBMENU_DEFAULT_VALUE,
}) {
  return `idwell-api/api/v3/table/filter-states/${entityPlural}/${sub}/?object_id=${objectId}`
}

export function updateEntityTabTableConfig(data, entityPlural) {
  return putApi({
    data,
    endpoint: `idwell-api/api/v3/table/tables/${entityPlural}/config/`,
  })
}
